module.exports = __webpack_public_path__ + "static/img/platform-1.bcbcfa66.png";